export const Labels = {
	logo_description: 'Powering Product Discovery at Expo West and Newtopia Now 🚀',
	first_description: 'Find the Future. Be the Future.',
	second_description:
		'Connecting the innovators behind tomorrow’s products with the buyers who bring them to life.'
};
